// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions} from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDEmB2c5zKEmCZ8VIzmMZp_4GOS4X2ZWB8",
  authDomain: "sia-flight-tracker-fb5a0.firebaseapp.com",
  projectId: "sia-flight-tracker-fb5a0",
  storageBucket: "sia-flight-tracker-fb5a0.firebasestorage.app",
  messagingSenderId: "152068901297",
  appId: "1:152068901297:web:a01b9c24fd932041aa9590",
  measurementId: "G-RH3BCLN5LT"
};

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Initialize Functions with the correct region (check your Firebase Console)
export const functions = getFunctions(app, 'us-central1');

// Uncomment to use emulator during development
// if (window.location.hostname === 'localhost') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }

export default app;